import { render, staticRenderFns } from "./headLogo.vue?vue&type=template&id=2e06f889&scoped=true&"
import script from "./headLogo.vue?vue&type=script&lang=js&"
export * from "./headLogo.vue?vue&type=script&lang=js&"
import style0 from "./headLogo.vue?vue&type=style&index=0&id=2e06f889&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e06f889",
  null
  
)

export default component.exports